import { QueryFactory } from "../../../../Common";
import { BS } from "../../../../Contracts";
export const QPlaceBets = QueryFactory(BS.QueryTypes.PlaceBets);
//# sourceMappingURL=QPlaceBets.js.map